// extracted by mini-css-extract-plugin
export default {"cashless_title":"CashlessTitle_cashless_title__wac5Q"};